	jQuery(document).ready(function() {
	console.log("test header");
	//
     jQuery('.image-text__image-wrapper--primary img').attr("alt","here alt text should come ");
     jQuery('#ModalOpenerBtn-post_7d773m img').attr("alt","");
     jQuery('.image-text__image-wrapper.image-text__image-wrapper--secondary img').attr("alt","");
     jQuery('.image-text__image-wrapper.image-text__image-wrapper--primary img').attr("alt","");
     jQuery('#ModalOpenerBtn-post_7d773m img, #ModalOpenerBtn-post_mykQKn img, #ModalOpenerBtn-post_mykQKn img').attr("alt","");
     jQuery('.sm-feed-popup__post.sm-feed-popup__post--video img').attr("alt","");
     jQuery('.mv-center a').attr("aria-label","Phard Patchwork Denim Micro Mini Skirt | Italian Vintage");
     jQuery('.closer-desktop').attr("aria-label","close");
     jQuery('.sm-feed-popup__post-media-wrapper.sm-feed-popup__post-media-wrapper--video img').attr("alt","");
     jQuery('.sm-feed-popup__post-video img').attr("alt","");
     jQuery('.search__input').attr("aria-label","search");
     jQuery('#main-search-filters').removeAttr("aria-labelledby");
     jQuery('.closer.mobile-facets__close').attr("aria-label","close");
     jQuery('.closer.mobile-facets__close').attr("aria-label","close");
     jQuery('.video-banner__content a').attr("tabindex","-1");
     jQuery('.video-banner__content a').attr("aria-label","video");
     jQuery('.video-banner__content a').attr("aria-label","video");
     jQuery('.section-template--25960126054721__video_banner_9QUxgx  img').attr("alt","");
     jQuery('#h-captcha-response-0wiq7bd8def').attr("aria-label","captcha");
     jQuery('.video-banner__image-wrapper img').attr("alt","");

     jQuery('.link.link-with-icon.image-banner__inner-link.animate.animated').attr("aria-label","Visit homepage");
     jQuery('.gallery-viewer__close-icon').attr("title","close");
     jQuery('.image-banner__image-wrapper.image-banner__image-wrapper--desktop img').attr("alt","US Size chart");


	jQuery('video[playsinline="playsinline"] img').attr('alt', '');
	jQuery('a[href="/"]').attr('aria-label', 'Visit homepage');

	 
	// jQuery('a[href="/san-bernardino-retirement-home/"]').attr('aria-label', 'ariaLabel');
	// jQuery('a:contains("Ask a question!")').attr('aria-label', 'Ask a question!');
  	// jQuery('a .icon-yelp').parent('a').attr('aria-label', "Visit Benny's Tacos on Yelp (opens in new tab)");


	    setTimeout(function(){ 
        jQuery('.sm-feed-popup__post-video img').attr("alt","");
		jQuery('#main-search-filters').removeAttr("aria-labelledby");
	jQuery('video[playsinline="playsinline"] img').attr('alt', '');
     jQuery('.link.link-with-icon.image-banner__inner-link.animate.animated').attr("aria-label","Visit homepage");
     jQuery('.gallery-viewer__close-icon').attr("title","close");

     },
  2000); 


   });



$(document).ready(function() {
  // Select all h2s that don't have text and don't have children (like icons/spans)
  $('h4').filter(function() {
    // 1. Trim whitespace to catch " "
    const isEmpty = $.trim($(this).text()) === "";
    
    // 2. Ensure it doesn't have child elements (like an <img> or <span>)
    const hasNoChildren = $(this).children().length === 0;

    // 3. Accessibility Safety: Don't remove if it's a target for an aria-labelledby
    const isNotReferenced = !$(this).attr('id') || $('[aria-labelledby*="' + $(this).attr('id') + '"]').length === 0;

    return isEmpty && hasNoChildren && isNotReferenced;
  }).remove();
});


$('.product-description__container h4').each(function() {
  if ($.trim($(this).text()) === '') {
    $(this).remove();
  }
});